import React, { useEffect, useState } from "react";
import Components from "../../../components";
import Client from "../../../services";

const AddStudent = ({onClickStudent}) => {
    const [searching, setSearching] = useState(false)
    const [showResult, setShowResult] = useState(false)
    const [value, setValue] = useState("")
    const [student, setStudent] = useState(null)
    let timeoutId = -1
    const searchStudent = async (e, callback) => {
        const { value } = e.target
        if (showResult === false) setShowResult(true)
        clearTimeout(timeoutId)
        // setSid(value)
        if (value.length < 3) {
            callback([])
            // setShowList(false)
        }
        timeoutId = setTimeout(async () => {
            // setSearching(true)
            const { success, data } = await Client.api.get('/management/student/search?qname=' + value)
            if (success) {
                callback(data)
                // setShowList(data.length > 0)
            } else {
                callback([])
                // setShowList(false)
            }
            setSearching(false)
        }, 500)
    }

    const getStudentData = async (id) => {
        setShowResult(false)        
        const { success, data } = await Client.api.get('/management/student/' + id)
        if (success) {
            setStudent(data)
        } else {
            setStudent(null)
        }
    }
    useEffect(() => {
        console.log(student)
        onClickStudent( student ?  student._id : "")
    }, [student])
    return <div className="course-batch__add-student">
        <table>
            <tbody>
                <tr>
                    <td>Student Id</td>
                    <td>
                        <Components.input.Search
                            placeholder="Search student name or id"
                            onValueChange={searchStudent}
                            show={showResult}
                            render={(student) => {
                                console.log(student)
                                return <div
                                    className="course-batch__search-result-item"
                                    onClick={() => {
                                        // setSid(student._id)
                                        getStudentData(student._id)
                                    }}
                                >
                                    <div>{student.name}</div>
                                    <div>{student.username}</div>
                                </div>
                            }}
                        />
                    </td>
                </tr>
            </tbody>
        </table>
        {
            student && 
            <table>
                <tbody>
                    <tr>
                        <td>Student Id</td>
                        <td>{student.username}</td>
                    </tr>
                    <tr>
                        <td>Student Name</td>
                        <td>{student.name}</td>
                    </tr>
                    <tr>
                        <td>Address</td>
                        <td>{student.address}</td>
                    </tr>
                </tbody>
            </table>
        }
    </div>
}

export default AddStudent